<template>
    <div class="approve_admin_approval_handover_wrap">
        <div class="prompt_text">
            审批交接适用于人员离职、调岗等多种场景，可交接待处理的审批单（审批、办理、抄送），如涉及到非固定人员审批则需更换人员身份（直属上级、部门负责人等），已经审批通过的审批单不可变换交接人员
        </div>
        <div class="connect_wrap">
            <el-form label-position="top" size="small">
                <el-form-item label="被交接人" required>
                    <div class="connect_form">
                        <div>
                            <el-select
                                placeholder="请选择人员"
                                :remote-method="getUserList"
                                filterable
                                remote
                                v-model="connectForm.uid"
                                @change="getTableData"
                            >
                                <el-option
                                    :key="user.uid"
                                    :label="user.name"
                                    :value="user.uid"
                                    v-for="user in userList"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <el-button
                            @click="handleClickConnect"
                            type="primary"
                            v-if="multipleSelection && multipleSelection.length > 0"
                            >批量交接</el-button
                        >
                    </div>
                </el-form-item>
            </el-form>
            <p class="total_wrap">共{{ pendingData.length }}条数据</p>
            <div class="table_wrap">
                <el-table
                    class="custom_table"
                    :data="pendingData"
                    border
                    @selection-change="handleSelectionChange"
                    height="400px"
                    ref="multipleTable"
                >
                    <el-table-column align="center" type="selection" width="50"></el-table-column>
                    <el-table-column label="审批名称" prop="approval_set_name"></el-table-column>
                    <el-table-column label="待处理审批" prop="count" align="right" min-width="94"></el-table-column>
                    <el-table-column label="审批身份" prop="role_name">
                        <template slot-scope="{ row }">
                            <span v-if="row.role_name && row.role_name.length">{{ row.role_name.join("、") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="{ row }">
                            <el-button @click="handleClickHandover(row)" type="text">交接</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <approvalHandoverDialog
            :approvalHandoverDialog.sync="approvalHandoverDialog"
            :approvalHandoverDetails="approvalHandoverDetails"
            :receiverInfo="receiverInfo"
            @success="handoverSuccess"
            v-if="approvalHandoverDialog"
        />
    </div>
</template>
<script>
import { GetUserList, ApprovalTransferList } from "@/api";
import approvalHandoverDialog from "../component/approvalHandover";
export default {
    name: "ApprovalHandover",
    components: {
        approvalHandoverDialog,
    },
    data() {
        return {
            connectForm: {
                uid: "",
                handler: "",
                role: [],
                co_type_id: "",
                approve_ids: "",
            },
            // connectFormRules: {
            //     role: [{ required: true, message: "请选择交接内容", trigger: "change" }],
            //     handler: [{ required: true, message: "请选择交接人", trigger: "change" }],
            // },
            pendingData: [],
            multipleSelection: [],
            approvalHandoverDialog: false,
            approvalHandoverDetails: {}, // 当前审批交接数据
            receiverInfo: {}, // 被交接人信息
            userList: [],
        };
    },
    created() {
        this.getUserList();
    },
    methods: {
        getUserList(name) {
            GetUserList({ keyword: name }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        // 批量处理交接
        handleClickConnect() {
            const approval_set_id = this.multipleSelection.map((item) => item.approval_set_id);
            const approval_ids = this.multipleSelection.map((item) => item.approval_ids).flat(Infinity);
            const role_name = this.multipleSelection.map((item) => item.role_name).flat(Infinity);
            this.receiverInfo = this.userList.find((item) => item.uid == this.connectForm.uid);

            let data = {
                receiver: this.connectForm.uid,
                approval_set_id,
                approval_ids,
                role_name,
            };
            this.approvalHandoverDetails = data;
            this.approvalHandoverDialog = true;
        },
        // 表格选择
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 交接
        handleClickHandover(row) {
            let approvalHandoverDetails = JSON.parse(JSON.stringify(row));
            approvalHandoverDetails.receiver = approvalHandoverDetails.receiver || this.connectForm.uid;
            this.approvalHandoverDetails = approvalHandoverDetails;
            this.receiverInfo = this.userList.find((item) => item.uid == this.connectForm.uid);
            this.approvalHandoverDialog = true;
        },
        handoverSuccess() {
            this.getTableData();
        },
        // 表格数据
        getTableData() {
            ApprovalTransferList({ uid: this.connectForm.uid }).then((res) => {
                if (res.code === 200) {
                    this.pendingData = res.data || [];
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.approve_admin_approval_handover_wrap {
    max-width: 950px;
    height: 100%;
    margin: 0 auto;
    padding: 16px;
    box-sizing: border-box;
    .connect_wrap {
        width: 100%;
        margin-top: 24px;
        .connect_form {
            display: flex;
            justify-content: space-between;
        }
        .total_wrap {
            padding: 4px 0 8px;
            font-size: 12px;
            line-height: 18px;
            color: rgba(102, 102, 102, 1);
        }
        .table_wrap {
            border-radius: 8px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.08);
        }
    }
}
.prompt_text {
    background: #edf0f4;
    padding: 8px;
    border-radius: 2px;
    line-height: 22px;
    border: none;
    color: rgba(51, 51, 51, 1);
    font-size: 12px;
}
</style>
